/* global axios */
import ApiClient from './ApiClient';

class WhatsappCampaignsAPI extends ApiClient {
  constructor() {
    super('whatsapp_campaigns', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(campaign) {
    return axios.post(this.url, { campaign });
  }

  update(id, campaign) {
    return axios.patch(`${this.url}/${id}`, { campaign });
  }

  launch(id, action) {
    return axios.post(`${this.url}/${id}/launch`, { action });
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  getRecipients(id, params = {}) {
    return axios.get(`${this.url}/${id}/recipients`, { params });
  }

  exportCampaign(id) {
    return axios.get(`${this.url}/${id}/export`, { responseType: 'blob' });
  }

  estimateReach(payload) {
    return axios.post(`${this.url}/estimate_reach`, payload);
  }
}

export default new WhatsappCampaignsAPI();
